import { render } from "./OperatorDashboard.vue?vue&type=template&id=b78263a6"
import script from "./OperatorDashboard.vue?vue&type=script&lang=js"
export * from "./OperatorDashboard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__